import React from 'react'
// import { useTbViewStore } from '@vt/hooks'
import DefaultMap from './maps/map-export'
// import MapArea from './maps/map-area'
// import MapGeo from './maps/map-geo'
import { showDetail } from '../../details-copy'

/**
 * @file 地图视图
 * @author liuziyun
 */

const Map = function ({ showTbDetail = showDetail }) {
  // const mapConfig = useTbViewStore((state) => state.mapConfig)

  return <DefaultMap showTbDetail={showTbDetail} />
}

export default Map
